import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
interface SlideReframeProps {
  onContinue: () => void;
}
export function SlideReframe({
  onContinue
}: SlideReframeProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const timer1 = setTimeout(() => setStage(1), 1500);
    const timer2 = setTimeout(() => setStage(2), 3000);
    const timer3 = setTimeout(() => setStage(3), 4500);
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);
  const bullets = ['Maintained', 'Not continuously optimized', 'Not systematically improved'];
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative" data-id="element-367">
      {/* Dynamic Background Shift */}
      <motion.div className="absolute inset-0 z-0" animate={{
      background: stage >= 2 ? 'radial-gradient(circle at 50% 50%, rgba(0, 212, 170, 0.1) 0%, rgba(11, 17, 32, 1) 70%)' : 'radial-gradient(circle at 50% 50%, rgba(21, 30, 50, 0.5) 0%, rgba(11, 17, 32, 1) 70%)'
    }} transition={{
      duration: 2
    }} data-id="element-368" />

      <div className="z-10 max-w-4xl w-full space-y-12" data-id="element-369">
        <div className="space-y-4" data-id="element-370">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-serif text-white" data-id="element-371">
            This is not{' '}
            <motion.span initial={{
            opacity: 0,
            y: -10,
            rotate: -2
          }} animate={{
            opacity: 1,
            y: 0,
            rotate: -2
          }} transition={{
            delay: 0.8,
            duration: 0.4
          }} className="inline-block text-teal-400 font-serif italic mx-2" data-id="element-372">
              only
            </motion.span>{' '}
            a marketing problem.
          </motion.h2>

          <motion.h3 initial={{
          opacity: 0
        }} animate={{
          opacity: stage >= 1 ? 1 : 0
        }} transition={{
          duration: 1
        }} className="text-3xl md:text-5xl font-serif text-teal-400" data-id="element-373">
            It's an operating model problem.
          </motion.h3>
        </div>

        <div className="pt-12 space-y-6" data-id="element-374">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: stage >= 2 ? 1 : 0
        }} className="text-xl text-white/50 uppercase tracking-widest font-medium" data-id="element-375">
            Legacy brands are:
          </motion.p>

          <div className="flex flex-col items-center gap-4" data-id="element-376">
            {bullets.map((bullet, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: stage >= 2 ? idx <= (stage - 2) * 2 ? 1 : 0 : 0,
            y: 0
          }} transition={{
            delay: idx * 0.5
          }} className={`text-2xl md:text-3xl font-medium ${idx === 0 ? 'text-white/40' : 'text-white'}`} data-id="element-377">
                {bullet}
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 3 ? 1 : 0,
        y: stage >= 3 ? 0 : 20
      }} transition={{
        delay: 1.5
      }} className="pt-12" data-id="element-378">
          <Button onClick={onContinue} variant="primary" className="px-8 py-4 text-lg" data-id="element-379">
            See a different approach
          </Button>
        </motion.div>
      </div>
    </div>;
}